import {Injectable} from '@angular/core';
import {NgxSmartModalService} from 'ngx-smart-modal';

@Injectable()
export class ErrorMessageService {
  constructor(private smartModalService: NgxSmartModalService) {
  }

  private static fromStatusCode(statusCode: number, customErrors: { [key: number]: string } = {}): string {
    const errors = Object.assign({
      0: 'Er kon geen verbinding gemaakt worden met de dienst. Controleer je internetverbinding en probeer het opnieuw.',
      401: 'Je moet eerst inloggen voordat je dit mag doen.',
      403: 'Sorry, je hebt geen toestemming om dit te doen.',
      404: 'De link die je gebruikt hebt werkt niet. Neem contact met ons op als dit blijft voorkomen.',
      500: 'Er is een fout opgetreden bij het verwerken van je aanvraag. We zullen dit zo snel mogelijk oplossen.',
      503: 'De dienst is helaas op dit moment niet beschikbaar. Probeer het later opnieuw.'
    }, customErrors);
    return errors[statusCode] || 'Er is een onverwachte fout opgetreden: ' + statusCode;
  }

  private static fromString(errorString: string, customErrors: { [key: string]: string } = {}): string {
    const errors = Object.assign({
      'cordova_not_available': 'Dit wordt helaas niet ondersteund op jouw apparaat.'
    }, customErrors);
    return errors[errorString] || 'Er is een onverwachte fout opgetreden: ' + errorString;
  }

  public present(error: any,
                 customErrors: { [key: number]: string } = {},
                 onClose: (event: any) => void = () => {
                 }): void {
    console.error(error);
    try {
      const modal = this.smartModalService.getModal('errorMessageModal');
      modal.setData({message: this.generate(error, customErrors)});
      modal.onAnyCloseEvent.subscribe(event => {
        onClose(event);
      });
      modal.open();
    } catch (modalError) {
      console.error('Could not find error message modal', modalError, modalError.stack);
    }
  }

  public generate(error: any, customErrors: { [key: number]: string } = {}): string {
    if (error == null) {
      return null;
    }

    if (error.hasOwnProperty('status')) {
      return ErrorMessageService.fromStatusCode(error.status, customErrors);
    } else if (typeof error === 'string') {
      return ErrorMessageService.fromString(error, customErrors);
    } else {
      return error;
    }
  }
}
